stockService.$inject = ['$http', '$httpParamSerializer']
function stockService($http, $httpParamSerializer) {
    let stockList;
    let storedChart = {};
    let activeTab = 1;
    let currentMaterial = '';

    const initChart = () => {
        if (storedChart && storedChart.data && storedChart.options) {
            return storedChart;
        }
        return {};
    }

    const setChart = (chart) => storedChart = chart;


    // helpers for active tab control
    const setActiveTab = (index) => activeTab = index;
    const getActiveTab = () => activeTab;

    // finds list of materials and their critical leveles
    const find = () => {
        if (stockList) return Promise.resolve(stockList);

        return $http.get('/api/stock/')
            .then(res => res.data)
            .then(stock => {
                angular.copy(stock, stockList); return stock;
            })
            .catch(errorHandler);
    }

    // finds statistics, used to plot chart
    const findStats = () => {
        return $http.get('/api/stock/stats')
            .then(res => res.data)
            .catch(errorHandler);
    }

    // get information about the item itself (forecast orders, average sales etc)
    const get = (materialId) => {
        return $http.get('/api/stock/' + materialId)
            .then(res => res.data)
            .catch(errorHandler);
    }

    // finds and breaks simulation chart into objects
    const getChart = (materialId) => {
        return $http.get('/api/stock/' + materialId + '/chart')
            .then(res => res.data)
            .then(charts => {

                charts.history = _.map(charts.history, (coord) => { coord.x = moment(coord.x).toDate(); return coord });
                charts.simulation = _.map(charts.simulation, (coord) => {
                    // coord.x = moment(coord.x).toDate(); 
                    // console.log(coord.x,new Date(moment(coord.x).tz('America/Sao_Paulo').format('YYYY-MM-DD HH:mm')));
                    // coord.x = new Date(moment(coord.x).tz('America/Sao_Paulo').format('YYYY-MM-DD HH:mm')); 
                    // coord.x = moment(coord.x).utcOffset('-03:00').toDate()//format('YYYY-MM-DD HH:mm')); 

                    const d = new Date()
                    const userOffset = d.getTimezoneOffset() * 60000
                    const brazilOffset = 2 * 60 * 60000 * (-1)
                    coord.x = new Date(new Date(coord.x).getTime() + userOffset + brazilOffset)

                    return coord
                });
                charts.simulation1 = _.filter(charts.simulation, (coord) => coord.id == 1);
                charts.simulation2 = _.filter(charts.simulation, (coord) => coord.id == 2);
                charts.simulation3 = _.filter(charts.simulation, (coord) => coord.id == 3);
                charts.simulation4 = _.filter(charts.simulation, (coord) => coord.id == 4);
                charts.simulation5 = _.filter(charts.simulation, (coord) => coord.id == 5);
                charts.simulation6 = _.filter(charts.simulation, (coord) => coord.id == 6);
                charts.simulation7 = _.filter(charts.simulation, (coord) => coord.id == 7);
                charts.simulation8 = _.filter(charts.simulation, (coord) => coord.id == 8);
                charts.simulation9 = _.filter(charts.simulation, (coord) => coord.id == 9);

                delete charts.simulation;

                return charts;
            })
            .catch(errorHandler);
    }

    const getRegionalSalesChart = (materialId, startDate, endDate) => {
        let defaultEndDate = moment().format('YYYY-MM-DD');
        let defaultStartDate = moment().subtract(12, 'month').endOf('month').format('YYYY-MM-DD');

        let query = "";
        if (startDate && endDate) query = $httpParamSerializer({ start: startDate, end: endDate });
        if (!startDate && !endDate) query = $httpParamSerializer({ start: defaultStartDate, end: defaultEndDate });

        return $http.get('/api/stock/' + materialId + '/sales-chart/regional?' + query)
            .then(res => res.data)
            .catch(errorHandler);
    }

    const getSalesChart = (materialId, startDate, endDate) => {
        let query = "";
        if (startDate && endDate) query = $httpParamSerializer({ start: startDate, end: endDate });

        return $http.get('/api/stock/' + materialId + '/sales-chart?' + query)
            .then(res => res.data)
            .catch(errorHandler);
    }

    const getStockPOs = (materialId, eta) => {
        let url = '/api/stock/' + materialId + '/po';
        if (eta) url += '?eta_date=' + moment(eta).format('YYYY-MM-DD').toString();

        return $http.get(url)
            .then(res => res.data)
            .catch(errorHandler);
    }

    const getStockPOsByInspection = (materialId, inspectionId) => {
        let url = '/api/stock/' + materialId + '/po/' + inspectionId;

        return $http.get(url)
            .then(res => res.data)
            .catch(errorHandler);
    }

    const getStockHistory = (materialId, startDate, endDate) => {
        let query = void 0;
        if (startDate && endDate) query = $httpParamSerializer({ start: startDate, end: endDate });

        return $http.get('/api/stock/' + materialId + '/history?' + query || '')
            .then(res => res.data)
            .catch(errorHandler);
    }

    const getUserSimulationChart = (materialId, average) => {
        if (!average || !materialId) { alert.error('Please fill in all the data'); return; }

        return $http.get('/api/stock/' + materialId + '/chart/simulation?avg=' + average)
            .then(res => res.data)
            .then(charts => {

                // charts.history = _.map(charts.history, (coord) => { coord.x = moment(coord.x).toDate(); return coord });
                charts.simulation = _.map(charts, (coord) => {
                    coord.x = moment(coord.x).utcOffset('-03:00').toDate()//format('YYYY-MM-DD HH:mm')); 
                    return coord
                });
                charts.simulation1 = _.filter(charts, (coord) => coord.id == 1);
                charts.simulation2 = _.filter(charts, (coord) => coord.id == 2);
                charts.simulation3 = _.filter(charts, (coord) => coord.id == 3);
                charts.simulation4 = _.filter(charts, (coord) => coord.id == 4);
                charts.simulation5 = _.filter(charts, (coord) => coord.id == 5);
                charts.simulation6 = _.filter(charts, (coord) => coord.id == 6);

                // delete charts.simulation;

                return charts;
            })
            .catch(errorHandler)
    }

    const getDistributionCenterStock = (materialId) => {

        return $http.get('/api/stock/' + materialId + '/location')
            .then(res => res.data)
            .catch(errorHandler)
    }

    const getRegionalStockChart = (materialId) => {

        return $http.get('/api/stock/' + materialId + '/regional')
            .then(res => res.data)
            .catch(errorHandler);
    }

    return {
        currentMaterial,
        find,
        findStats,
        get,
        getChart,
        getSalesChart,
        getRegionalSalesChart,
        getRegionalStockChart,
        initChart,
        setChart,
        setActiveTab,
        getActiveTab,
        getStockPOs,
        getStockHistory,
        getStockPOsByInspection,
        getUserSimulationChart,
        getDistributionCenterStock
    };
}

app.service('stockService', stockService);
